import { motion } from "framer-motion";

const SPRING = { type: "spring" as const, stiffness: 300, damping: 30 };

const SECTION_VARIANTS = {
  hidden: { opacity: 0, y: 12 },
  visible: { opacity: 1, y: 0, transition: SPRING },
};

const MOCK_WEEKLY_POSTS = [
  { label: "Week 1", count: 8 },
  { label: "Week 2", count: 12 },
  { label: "Week 3", count: 6 },
  { label: "Week 4", count: 10 },
];

function WeeklyBar({
  label,
  count,
  maxCount,
}: {
  label: string;
  count: number;
  maxCount: number;
}) {
  const widthPercent = maxCount > 0 ? (count / maxCount) * 100 : 0;

  return (
    <div className="flex items-center gap-3">
      <span className="w-14 shrink-0 text-xs text-[var(--color-text-muted)]">
        {label}
      </span>
      <div className="flex h-6 flex-1 items-center rounded-[var(--radius-md)] bg-[var(--color-bg)]">
        <motion.div
          initial={{ width: 0 }}
          animate={{ width: `${widthPercent}%` }}
          transition={SPRING}
          className="flex h-full min-w-8 items-center justify-end rounded-[var(--radius-md)] bg-[var(--color-primary)] pr-2"
        >
          <span className="text-[10px] font-semibold text-white">
            {count}
          </span>
        </motion.div>
      </div>
    </div>
  );
}

export function AnalyticsSection() {
  const maxCount = Math.max(...MOCK_WEEKLY_POSTS.map((w) => w.count));

  return (
    <motion.section variants={SECTION_VARIANTS} className="mb-5">
      <h2 className="mb-2 text-xs font-semibold uppercase tracking-wider text-[var(--color-text-muted)]">
        Analytics
      </h2>
      <div className="rounded-[var(--radius-lg)] bg-[var(--color-surface)] shadow-sm p-4">
        <p className="mb-3 text-sm font-medium text-[var(--color-text)]">
          Posts per week
        </p>
        <div className="flex flex-col gap-3">
          {MOCK_WEEKLY_POSTS.map((week) => (
            <WeeklyBar
              key={week.label}
              label={week.label}
              count={week.count}
              maxCount={maxCount}
            />
          ))}
        </div>
      </div>
    </motion.section>
  );
}
